import { render, staticRenderFns } from "./coment.vue?vue&type=template&id=4a61ba26&scoped=true"
import script from "./coment.vue?vue&type=script&lang=js"
export * from "./coment.vue?vue&type=script&lang=js"
import style0 from "./coment.vue?vue&type=style&index=0&id=4a61ba26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a61ba26",
  null
  
)

export default component.exports